/**
 * @Author 金一泽
 * @Description 联系我们
 */
/** 新增 */
export const ADD_CONTACTUS = "/api/contactUs/add";
